module.exports = __webpack_public_path__ + "static/media/lesliFellman.a0146826.jpg";